export default "__VITE_ASSET__N8THQCiGQAK_wQXofhkUjg__ 480w, __VITE_ASSET__bLNX6U6f8qE7L2W0pHPLmA__ 768w, __VITE_ASSET__Jhiobz1iAIl42UC3k5$exQ__ 1200w";